import { carouselItems } from '@/mocks/darkwebData';

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[1440px] mx-auto">
        <div className="mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
            焦点专题
          </h2>
          <p className="text-foreground-600 text-sm mt-2">
            暗网核心议题深度策划，一文读懂关键领域
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-5">
          {carouselItems.map((item) => (
            <article
              key={item.id}
              className="group bg-background-100 border border-background-200/70 rounded-lg overflow-hidden hover:border-primary-300 transition-colors cursor-pointer flex flex-col"
            >
              <div className="relative aspect-[2/1] bg-background-200 overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/50 via-transparent to-transparent"></div>
                <div className="absolute top-4 left-4">
                  <span className="bg-accent-500 text-background-50 text-xs px-2.5 py-0.5 rounded font-medium">
                    {item.badge}
                  </span>
                </div>
              </div>
              <div className="p-5 flex flex-col flex-1">
                <h3 className="font-heading text-base md:text-lg font-bold text-foreground-950 mb-3 leading-snug">
                  {item.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed flex-1">
                  {item.description}
                </p>
                <div className="mt-4 pt-4 border-t border-background-200/70">
                  <span className="inline-flex items-center text-sm text-primary-500 font-medium cursor-pointer">
                    阅读专题
                    <i className="ri-arrow-right-line ml-1"></i>
                  </span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}